// @flow
import type { School } from 'types'
import { get } from 'util/api'

export function fetch(idOrSlugOrShortname: number | string): Promise<School> {
  return get(`/api/schools/${idOrSlugOrShortname}`).then(response => response.json.school)
}
